import { useMemo } from 'react';

import { Bets } from '../../../config/bets';
import { useMWStateSlice } from '../../../store/slices/mwState/selectors';

export const useIsWinningBetSpotConnected = (betSpot: Bets): boolean => {
  const gameResult = useMWStateSlice.getGameResult();

  return useMemo((): boolean => {
    return gameResult?.betSpot === betSpot;
  }, [gameResult, betSpot]);
};
